/**
 * Revoked Tokens Repository
 * 
 * Data access layer for Revoked Tokens DynamoDB table
 */

import { DeleteCommand, GetCommand, PutCommand } from '@aws-sdk/lib-dynamodb';
import { RevokedToken } from '../types/dynamodb.types';
import { TABLE_NAMES, dynamoDbClient } from './dynamodb.config';

export class RevokedTokensRepository {
  /**
   * Revoke a token
   */
  async revokeToken(revokedToken: RevokedToken): Promise<RevokedToken> {
    const command = new PutCommand({
      TableName: TABLE_NAMES.REVOKED_TOKENS,
      Item: revokedToken,
    });

    await dynamoDbClient.send(command);
    return revokedToken;
  }

  /**
   * Check if token is revoked
   */
  async isTokenRevoked(token: string): Promise<boolean> {
    const command = new GetCommand({
      TableName: TABLE_NAMES.REVOKED_TOKENS,
      Key: { token },
    });

    const result = await dynamoDbClient.send(command);
    return !!result.Item;
  }

  /**
   * Get revoked token details
   */
  async getRevokedToken(token: string): Promise<RevokedToken | null> {
    const command = new GetCommand({
      TableName: TABLE_NAMES.REVOKED_TOKENS,
      Key: { token },
    });

    const result = await dynamoDbClient.send(command);
    return (result.Item as RevokedToken) || null;
  }

  /**
   * Delete revoked token (for cleanup)
   */
  async deleteRevokedToken(token: string): Promise<void> {
    const command = new DeleteCommand({
      TableName: TABLE_NAMES.REVOKED_TOKENS,
      Key: { token },
    });

    await dynamoDbClient.send(command);
  }
}

export const revokedTokensRepository = new RevokedTokensRepository();
